import React, { useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { SnackbarTimeoutSeconds } from '@ferris/react/components/snackbar/Snackbar';
import { Snackbar } from '@ferris/react/components/snackbar';
import { TrackingContext } from '@vrbo/react-event-tracking';
import { createImpressionEvent } from '../../../../utils/EventProviders/EgClickstreamUtil';
import ResendEmailBtn, { TYPES } from '../ResendEmailBtn';

const EmailIsVerifiedError = ({
    title, text, cta, reason, propertyId, sentText
}) => {
    const { trigger } = useContext(TrackingContext);
    const [isSent, setIsSent] = useState(false);

    useEffect(() => {
        trigger('impression', createImpressionEvent('email_verified_error.presented', 'is_email_verified', reason, '2.3.0'));
    }, []);

    const onClick = () => {
        setIsSent(false);
        setIsSent(true);
    };

    return (
        <section className={cn('email-verified-section')}>
            <div className={cn('email-verified-content')}>
                <h1>{title}</h1>
                <p>{text}</p>
                {
                    propertyId && (
                        <div className={cn('email-verified-content')}>
                            <ResendEmailBtn
                                type={TYPES.BTN}
                                text={cta}
                                propertyId={propertyId}
                                callbackFn={onClick}
                            />
                            <Snackbar
                                classes={cn('hotel-onboarding-snackbar')}
                                visible={isSent}
                                timeout={SnackbarTimeoutSeconds.FOUR}
                            >
                                <span>{sentText}</span>
                            </Snackbar>
                        </div>
                    )
                }
            </div>
        </section>
    );
};

EmailIsVerifiedError.propTypes = {
    reason: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    propertyId: PropTypes.string.isRequired,
    sentText: PropTypes.string.isRequired
};

export default EmailIsVerifiedError;
